import { Box, Typography, Button, Container } from "@mui/material";

export default function SupportSection() {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          backgroundColor: "#f8f4ff",
          py: 8,
          px: 2,
          mt: "4%",
          mb: "4%",
          borderRadius: "20px",
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 600,
            color: "#1a1a1a",
            mb: 1,
          }}
        >
          Still Have Questions?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#666",
            maxWidth: "600px",
            mb: 2,
          }}
        >
          Our founder team is here to help. Get direct answers to your specific
          concerns.
        </Typography>

        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#8b5cf6",
            color: "white",
            textTransform: "none",
            px: 4,
            py: 1.5,
            fontSize: "1rem",
            fontWeight: 500,
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#7c3aed",
            },
          }}
        >
          Apply Now & Get Personal Support
        </Button>
      </Box>
    </Container>
  );
}
